/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ValidEmotion = (typeof ValidEmotion)[keyof typeof ValidEmotion];

export const ValidEmotion = {
  criticism: 'criticism',
  frustration: 'frustration',
  confusion: 'confusion',
  disappointment: 'disappointment',
  thankfulness: 'thankfulness',
  anger: 'anger',
  disapproval: 'disapproval',
  concern: 'concern',
  hate: 'hate',
  satisfaction: 'satisfaction',
  sexual_desire: 'sexual_desire',
  annoyance: 'annoyance',
  appreciation: 'appreciation',
  sadness: 'sadness',
  regret: 'regret',
  uncertainty: 'uncertainty',
  violence: 'violence',
  disgust: 'disgust',
  anxiety: 'anxiety',
} as const;
